import { render, staticRenderFns } from "./Regulatory.vue?vue&type=template&id=03a9dfb8&"
import script from "./Regulatory.vue?vue&type=script&lang=js&"
export * from "./Regulatory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports